import bilAPI from "../api";

export const changePassword = (currentPassword, newPassword) => {
  return new Promise((resolve, reject) => {
    try {
      const passwordData = {
        old_password: currentPassword,
        new_password: newPassword,
      };

      bilAPI
        .post("/auth/account/change_password/", passwordData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};
